import { applyChange } from "./applyChange";
import { Change } from "./change";
import { chunkPhonemes } from "./chunkPhonemes";

/**
 * apply a series of changes to an input string
 * @returns the results after being run thru all rules + the indices of rules that ran
 */
export function applyChanges(
  input: string, changes: Change[] | Change
): { output: string, rulesRun: number[] } {
  const phonemes = chunkPhonemes(input);

  let result = phonemes;
  const rulesRun: number[] = []
  if (Array.isArray(changes)) {
    changes.forEach((change, i) => {
      const { output, changed } = applyChange(result, change);
      if (changed) {
        result = output;
        rulesRun.push(i);
      }
    });
  } else {
    const { output, changed } = applyChange(result, changes);
    if (changed) {
      result = output;
      rulesRun.push(0);
    }
  }

  let output = '';
  result.forEach(p => output += p);
  return { output, rulesRun };
}
